import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import hidevLogo from '../assets/hidev_logo.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <Link to="/">
            <img src={logo} alt="Metropolitan Barbershop" />
          </Link>
        </div>
        <nav className="footer-nav">
          <Link to="/#about">About</Link>
          <Link to="/#services">Services</Link>
          <Link to="/smp">SMP</Link>
          <Link to="/san-francisco">San Francisco</Link>
          <Link to="/san-jose">San Jose</Link>
        </nav>
        <div className="footer-hidev">
          <a href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer">
            <img src={hidevLogo} alt="HiDev Mobile" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 